import { useEffect, useRef } from 'react'
import fluidImage from '../../assets/cc5436b188516fd27e1024f6052dd0ed.jpg'

interface FluidBackgroundProps {
  className?: string
  intensity?: number
}

export default function FluidBackground({ className = '', intensity = 1.0 }: FluidBackgroundProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    const resizeObserver = new ResizeObserver(() => {
      // Observer for future use if needed
    })
    resizeObserver.observe(containerRef.current)

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <div
      ref={containerRef}
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        width: '100%',
        height: '100%',
        opacity: intensity,
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${fluidImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </div>
  )
}
